export class AdditionalContactsModel {

    public id: string;
    public type: string;
    public value: string;


    constructor(obj?: any) {
        this.id       = obj && obj.id       || '';
        this.type     = obj && obj.type     || '';
        this.value    = obj && obj.value    || '';
    }


}



// WEBPACK FOOTER //
// ./src/app/models/additional-contacts.model.ts